// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"1ab3ac05","629":"02f65558","974":"2ea8dc15"}[chunkId] + ".chunk.js";
};